import { db } from "./firebase";
import { collection, getDocs } from "firebase/firestore";

export const getProperties = async () => {
  const properties = [];

  const collectionRef = collection(db, "propiedades");
  const snapshot = await getDocs(collectionRef);

  snapshot.forEach((doc) => {
    properties.push({ idFirebase: doc.id, ...doc.data() });
  });

  // Separar destacadas y no destacadas
  const highlighted = properties.filter((prop) => prop.highlights === true);
  const others = properties.filter((prop) => !prop.highlights);

  // Mezclar aleatoriamente las destacadas
  highlighted.sort(() => Math.random() - 0.5);

  // Unir ambas listas: primero destacadas (random) y luego las demás
  return [...highlighted, ...others];
};
